import React, { useState } from "react";
import styles from "./styles";
// MATERIAL UI
import { Grid, Container, Box, Hidden } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
// MATERIAL UI
// ASSETS
import imgLogin from "../../assets/images/marketing-estrategico.jpg";
import imgLogo from "../../assets/images/logo-link.png";
// ASSETS
// COMPONENTES
import Register from "./Forms/Register";
import Login from "./Forms/Login";
import RecoverPassword from "./Forms/RecoverPassword";
// COMPONENTES

function Auth(props) {
  const { classes } = props;
  const [form, setForm] = useState(0);

  const changeForm = (change) => {
    setForm(change);
  };

  return (
    <Grid container className={classes.container}>
      <Hidden xsDown>
        <Grid item xs={12} sm={6}>
          <img src={imgLogin} className={classes.imgLogin} alt="Marca" />
        </Grid>
      </Hidden>
      <Grid item xs={12} sm={6}>
        <Box
          display="flex"
          justifycontent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <Container component="main" maxWidth="sm">
            <div style={{ textAlign: "center" }}>
              <img src={imgLogo} alt="Marca" className={classes.imgLogo} />
            </div>
            <div className={classes.paper}>
              {form === 0 ? (
                <Login classes={classes} changeForm={changeForm} />
              ) : form === 1 ? (
                <Register classes={classes} changeForm={changeForm} />
              ) : (
                <RecoverPassword classes={classes} changeForm={changeForm} />
              )}
            </div>
          </Container>
        </Box>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(Auth);
